import $ from "/js/libs/jquery-3.3.1.min.js"

const baseMessage = {
  "visit_id": "04544fc4-eef3-4ee8-8429-80fab0984f57",
  "card_id": "1B00533D17",
  "last_station": "RFID-101",
  "lang": "fr",
  "state": "idle",
  "completed": false,
  "createdAt": "2024-11-26T13:34:25.000Z",
  "finishedAt": "2024-11-26T13:34:25.000Z",
  "progress": [],
  // "progress": [{"id": 29, "station": "RFID-101", "state": "idle"}],
  "timestamp": "2024-11-26T13:34:25.398Z"
};

export class Simulator {

  constructor(rfidScanCallback, baseStationRfid, debugMode) {
    this.el = $(".simulator");
    this.rfidScanCallback = rfidScanCallback;
    this.currentQuestBaseStationRFID = baseStationRfid;
    console.log(`Simulator: ${this.currentQuestBaseStationRFID}.`);

    this.fields = [
      {"type": "visit_id", "name": "visitorid"},
      {"type": "lang", "name": "language"},

      {"type": "progress", "name": "RFID-101"},
      {"type": "progress", "name": "RFID-234"},
      {"type": "progress", "name": "RFID-235"},
      {"type": "progress", "name": "RFID-236"},
      {"type": "progress", "name": "RFID-237"},

      {"type": "progress", "name": "RFID-102"},
      {"type": "progress", "name": "RFID-240"},

      {"type": "progress", "name": "RFID-103"},
      {"type": "progress", "name": "RFID-243"},

      {"type": "progress", "name": "RFID-104"},
      {"type": "progress", "name": "RFID-244"},

      {"type": "progress", "name": "RFID-105"},
      {"type": "progress", "name": "RFID-246"},
      {"type": "progress", "name": "RFID-247"},

      {"type": "progress", "name": "RFID-106"},
      {"type": "progress", "name": "RFID-248"},

      {"type": "progress", "name": "RFID-107"},
      {"type": "progress", "name": "RFID-250"},

      {"type": "progress", "name": "RFID-108"},
      {"type": "progress", "name": "RFID-251"},

      {"type": "progress", "name": "RFID-109"},
      {"type": "progress", "name": "RFID-252"},

      {"type": "progress", "name": "RFID-110"},
      {"type": "progress", "name": "RFID-253"},

      {"type": "progress", "name": "RFID-111"},
      {"type": "progress", "name": "RFID-255"},

      {"type": "progress", "name": "RFID-112"},
      {"type": "progress", "name": "RFID-257"},

      {"type": "progress", "name": "RFID-113"},

      {"type": "progress", "name": "RFID-114"},
      {"type": "progress", "name": "RFID-258"},

      {"type": "progress", "name": "RFID-115"},
      {"type": "progress", "name": "RFID-259"},

      {"type": "progress", "name": "RFID-116"},
      {"type": "progress", "name": "RFID-260"},

      {"type": "progress", "name": "RFID-117"},

      {"type": "progress", "name": "RFID-118"},
      {"type": "progress", "name": "RFID-261"},

      {"type": "progress", "name": "RFID-119"},
      {"type": "progress", "name": "RFID-263"},
      {"type": "progress", "name": "RFID-265"},
      {"type": "progress", "name": "RFID-266"},
      {"type": "progress", "name": "RFID-119"},

      {"type": "progress", "name": "RFID-120"},
      {"type": "progress", "name": "RFID-268"},

      {"type": "progress", "name": "RFID-121"},
      {"type": "progress", "name": "RFID-269"},
    ];

    // Create non visible elements
    for (let i = 0; i < this.fields.length; i++) {
      if ($(`[id='simulator-${this.fields[i].name}']`, this.el).length === 0) {
        const fieldName = `simulator-${this.fields[i].name}-status`;
        const hiddenField = `<input type='hidden' name='${fieldName}' id='${fieldName}' value="idle" />`;
        $("#simulator-form", this.el).append(hiddenField)
      }
    }

    // Keep RFIDs data from after a page refresh
    $("input, select", this.el).change(() => {
      this.saveToLocalStorage();
    });
    this.loadFromLocalStorage();

    // Allow to toggle simulator visibility using toggle button
    $(".simulator-toggle-collapse", this.el).click(() => {
      this.toggle();
    });

    // On rfid scan button
    $("#simulator-btn-tag-scan button", this.el).on("click", (e) => {
      e.preventDefault();
      this.simulateScan();
    });

    // Scan object
    $("input.object-scan", this.el).on("click", (e) => {
      e.preventDefault();
      const selectorObj = $(e.currentTarget).siblings("select");
      const secondOptionValue  = $("option", selectorObj).eq(1).val();
      selectorObj.val(secondOptionValue);
      this.saveToLocalStorage()
    });

    // Reset rfid data
    $("#simulator-btn-tag-reset button", this.el).on("click", (e) => {
      e.preventDefault();
      for (let i = 0; i < this.fields.length; i++) {
        const $el = $(`[name='simulator-${this.fields[i].name}-status']`);
        const options = $.map($el.find('option'), function (e) {
          return e.value;
        });
        $el.val(options[0]);
      }
      this.saveToLocalStorage()
    });

    // Simulate scan on arrow down
    $(document).keydown((e) => {
      // UP
      if (e.keyCode === 38) app.lastClick = app.screenRedirectDelay = 0;
      // DOWN
      if (e.keyCode === 40) this.simulateScan()
    });

    // Expand when NOT in debug mode
    if (debugMode) {
      this.expand();
    }

  }

  toggle() {
    (this.el.hasClass("collapsed")) ? this.expand() : this.collapse();
  }

  expand() {
    this.el.removeClass("collapsed");
  }

  collapse() {
    this.el.addClass("collapsed");
  }

  saveToLocalStorage() {
    const formData = JSON.stringify($("form", this.el).serializeArray());
    localStorage.setItem("simulatorData", formData);
  }

  loadFromLocalStorage() {
    const formData = JSON.parse(localStorage.getItem("simulatorData"));
    if (Array.isArray(formData)) {
      formData.forEach((values) => {
        $(`[name='${values.name}']`, this.el).val(values.value);
      })
    }
  }

  simulateScan(e) {
    const scanData = this.buildMessageFromInputs();
    scanData.last_station = this.currentQuestBaseStationRFID;
    this.rfidScanCallback(scanData);
  }

  updateBaseStationState(state) {
    // Set current base station dropdown to 'ongoing'
    for (let i = 0; i < this.fields.length; i++) {
      if (this.fields[i].name === this.currentQuestBaseStationRFID) {
        $(`[name='simulator-${this.fields[i].name}-status']`).val(state)
      }
    }
    this.saveToLocalStorage();
  }

  buildMessageFromInputs() {
    const progressValue = (name) => {
      const stringValue = $(`[name='simulator-${name}-status']`, this.el).val()?.toString()
      if (stringValue === "TRUE") return true;
      else if (stringValue === "FALSE") return false;
      else return stringValue;
    }

    // Build fields values
    const jsonData = structuredClone(baseMessage);
    for (let i = 0; i < this.fields.length; i++) {
      const fieldValue = progressValue(this.fields[i].name);
      if (this.fields[i].type === "visit_id") {
        jsonData["visit_id"] = fieldValue;
      } else if (this.fields[i].type === "lang") {
        jsonData["lang"] = fieldValue;
      } else {
        jsonData["progress"].push({
          "station": this.fields[i].name,
          "state": fieldValue
        });
      }
    }
    return jsonData;
  }
}
